import { useMemo } from 'react';
import useValidations from 'hooks/useValidations';
import { useTranslation } from 'react-i18next';
import { CROP_DEFAULT_PRODUCT_TYPE, MAX_CROP_QUANTITY_LIMIT } from 'appConstants';

export default function useValidationSchema(indexedProducts?: { [key: string]: number }) {
  const { t } = useTranslation('CreateCropOrder', { keyPrefix: 'ProductForm' });

  const { createSchema } = useValidations();
  return useMemo(() => {
    const fields = [
      {
        type: 'requiredString',
        label: t('labels.productType'),
        ruleName: 'productType',
        defaultValue: CROP_DEFAULT_PRODUCT_TYPE,
      },
      {
        type: 'requiredString',
        label: t('labels.product'),
        ruleName: 'packagedItemReference',
      },
      {
        type: 'cropPackNumber',
        ruleName: 'packagedItemQty',
        label: t('labels.packNumber'),
        context: {
          maxValue: MAX_CROP_QUANTITY_LIMIT,
          indexedProducts,
          maxNumberOfPacksError: (maxLimit: number) => t('errors.maxNumberOfPacks', { maxLimit }),
        },
      },
    ];
    return createSchema(fields);
  }, [t, indexedProducts, createSchema]);
}
